function openTab(event, tabName) {
    // Hide all tab contents for the current level
    var currentLevel = event.currentTarget.parentElement.parentElement;
    var tabContents = currentLevel.getElementsByClassName("tab-content");
    
    for (var i = 0; i < tabContents.length; i++) {
        tabContents[i].style.display = "none";
    }

    // Remove the active class from all tab buttons at the current level
    var tabButtons = currentLevel.getElementsByClassName("tab");
    for (var i = 0; i < tabButtons.length; i++) {
        tabButtons[i].classList.remove("active");
    }

    // Show the selected tab's content
    document.getElementById(tabName).style.display = "block";
    event.currentTarget.classList.add("active");
}
